import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionContext, Col, Row } from "react-bootstrap";
import NotificationCircle from "../../navbar/notification-circle";
import { LinkContainer } from "react-router-bootstrap";
import { NotificationIcon } from "../../icons";
import { RiArrowRightSLine, RiArrowDownSLine } from "react-icons/ri";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import "./index.css";

function NavAccordionToggle({ eventKey, callback }) {
  const { t } = useTranslation();
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <div
      onClick={decoratedOnClick}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          decoratedOnClick(e);
        }
      }}
      role="button"
      tabIndex={0}
      aria-expanded={isCurrentEventKey}
      aria-label={isCurrentEventKey ? t("Collapse notifications") : t("Expand notifications")}
    >
      {isCurrentEventKey ? <RiArrowDownSLine /> : <RiArrowRightSLine />}
    </div>
  );
}

function MemberNavAccordion(props) {
  const { t } = useTranslation();
  return (
    <Row className="nav-accordion-row">
      <Col className="nav-accordion-col" lg={{ span: 12 }}>
        <Accordion defaultActiveKey="1">
          <Accordion.Item eventKey="0">
            <Accordion.Header as="div">
              <Row className="nav-accordion-row">
                <Col>
                  <Row>
                    <Col className="nav-accordion-col">
                      <Row>
                        <Col>
                          <NotificationCircle className="sm-notification-icon-number" navNotificationType={props.navNotificationType} />
                          <span className="not-icon-container">
                            <NotificationIcon />
                          </span>
                          <span className="accordion-not-text">{t("navbar.notifications")}</span>
                        </Col>
                      </Row>
                    </Col>
                    <Col className="notification-accordion-icon-container">
                      <span className="icon">
                        <NavAccordionToggle eventKey="0" className="icon" />
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Accordion.Header>
            <Accordion.Body>
              <Row className="notification-dropdown-container">
                <Col>
                  {props.notifications.map((notification, index) => (
                    <LinkContainer
                      className="nav-accordion-links"
                      key={index}
                      to={notification.location}
                      onClick={() => props.onClick(index)}
                    >
                      <Row className="notification-dropdown-row-container">
                        <Col
                          className="notification-dd-icon-container"
                          lg={{ span: 2 }}
                          md={{ span: 2, offset: 1 }}
                          sm={{ span: 2, offset: 1 }}
                          xs={{ span: 2, offset: 1 }}
                        >
                          {notification.icon}
                        </Col>
                        <Col
                          className="notification-middle-text-container"
                          lg={{ span: 7 }}
                          md={{ span: 3 }}
                          sm={{ span: 3 }}
                          xs={{ span: 4 }}
                        >
                          <Row>
                            <Col>
                              <span className="notification-bold-text">{notification.title}</span>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <span className="notification-white-section-small-text">
                                {t("navbar.for")} {notification.for}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={{ span: 2 }} sm={{ span: 2 }} xs={{ span: 2, offset: 1 }} className="notification-right-text-container">
                          <span className="notification-white-section-time-text">{notification.when}</span>
                        </Col>
                      </Row>
                    </LinkContainer>
                  ))}
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
    </Row>
  );
}

export default MemberNavAccordion;
